
import { defineComponent } from 'vue';
import store from '@/store';

export default defineComponent({
  name: 'TrailReactionView',
  props: {
    trailid: String,
  },
  computed: {
    currentTrail() {
      return store.state.trailinfo;
    },
  },
  async mounted() {
    // eslint-disable-next-line no-restricted-globals
    location.reload();
  },
});
